import {  Modal, Form } from "antd";
import IntlMessages from "../../components/utility/intlMessages";
import React, { Component } from "react";
import { clearLogoutPopupData } from "../../redux/auth/actions";
import FormattedMessage from "../../components/utility/intlMessages";
// import {
//   setLogoutFlag,
//   modalOpenFlag,
//   modalCloseFlag,
// } from "../../redux/Logout/actions";

import { connect } from "react-redux";
import { Redirect } from "react-router";

class CustomStaticLogout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleDrawer: true,
      showDataRecipient: false,
      formLabel: true,
      modalVisibile: true,
    };
  }

  componentDidMount = () => {
    //this.props.modalOpenFlag();
  };

  handleOk = () => {
    this.props.clearLogoutPopupData();
    this.setState({
      redirectToSignin: true,
    });

  };

  render() {
    
    if (this.state.redirectToSignin === true) {
      return <Redirect to={"/signin"} />;
    }
    return (
      <div className="main-login-modal">
        <Modal
          title=""
          visible={this.state.modalVisibile}
          onOk={this.handleOk}
          className="main-login-modal"
          closable={false}
          cancelButtonProps={{ style: { display: "none" } }}
          //onCancel={this.handleCancel}
          okText={<FormattedMessage id="text.Ok" />}
        >
          <p>
            <IntlMessages id={"sidebar.logoutmessage"} />
          </p>
        </Modal>
      </div>
    );
  }
}

const WrappedCustomLogout = Form.create()(CustomStaticLogout);

export default connect((state) => ({}), {
  clearLogoutPopupData,
  // setLogoutFlag,
  // modalOpenFlag,
  // modalCloseFlag,
})(WrappedCustomLogout);
